import {
  Component,
  NgModule,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  ElementRef,
  EventEmitter,
  Output,
  OnDestroy
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl, FormsModule, Validators } from '@angular/forms';

import { DynamicControlErrorModule } from './dynamic-control-error.component';
import { BaseComponent } from '../../../../models/base/base.component';
import { Search, SearchFilter } from '../../../../models/search.model';

import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { KeyFilterModule } from 'primeng/keyfilter';
import { CalendarModule } from 'primeng/calendar';
import { DynamicValueModule } from './dynamic-value.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SearchService } from '../../../../services/search.service';
import { LookupService } from '../../../../services/lookup.service';
import { SimpleControlModule } from './simple-control.component';
import { NavigationService } from '../../../../services/navigation.service';
import { Subscription } from 'rxjs';
import { MultiSelectModule } from 'primeng/multiselect';
import { SharedService } from '../../../../services/shared.service';

@Component({
  selector: 'search-filter',
  templateUrl: './search-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [SearchService, LookupService]
})
export class SearchFilterComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  search: Search = new Search();
  @Input() entityName: string = null;
  @Input() subEntity: string = null;
  @Output() entityNameChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() filtersChange: EventEmitter<Search> = new EventEmitter<Search>();
  @Output() onSearch: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup = new FormGroup({}, []);
  lookups:any = {};
  role = null;
  visibleFilterOptions : SearchFilter[];
  searchForm: FormGroup = new FormGroup({}, []);
  loadingSubscriber : Subscription;

  filters: any[] = [];
  maxFilters = 5;
  selections: any[] = [];
  selectionLoading: any[] = [];
  sharedServiceClient: SharedService;
  roles = [];
  constructor(
    private changeRef: ChangeDetectorRef,
    private el: ElementRef,
    private searchService: SearchService,
    private lookupService: LookupService,
    private datePipe: DatePipe,
    private sharedService : SharedService,
    private navigationService: NavigationService) {
    super();
    this.sharedServiceClient = sharedService;
  }

  ngOnInit() {
    this.searchForm.addControl('ordernumber', new FormControl(''));
    this.searchForm.addControl('contactLastName', new FormControl(''));
    this.searchForm.addControl('customerPhone', new FormControl(''));
    this.searchForm.addControl('carrierPhone', new FormControl(''));

    this.loadingSubscriber = this.navigationService.loading$.subscribe(res => {
      this.isLoading = res;
      this.changeRef.detectChanges();
    });

    if (this.sharedServiceClient.getPermissions('customers')) {
      this.roles.push({ label: 'Customer', value: '1' })
    }
    if (this.sharedServiceClient.getPermissions('carriers')) {
      this.roles.push({ label: 'Carrier', value: '2' })
    }
    if (this.sharedServiceClient.getPermissions('agents')) {
      this.roles.push({ label: 'Agent', value: '3' })
    }
    let m = this.maxFilters;

    while (m > 0) {
      m--;
      this.selections.push(null);
      this.selectionLoading.push(false);
    }

    this.loadLookup('duration')
    this.entityName = 'order';
    this.changeEntity(true,true);
    this.search.duration = 1;
  }


  ngOnChanges(changes: SimpleChanges) {
    if (this.anyChange('entityName', changes)) {
      this.changeEntity();
    }
  }

  ngOnDestroy(): void {
    this.loadingSubscriber?.unsubscribe();
  }

  safeReadChange(key: string, changes: SimpleChanges): boolean {
    return changes[key] != null && !changes[key].firstChange && changes[key].currentValue != changes[key].previousValue
  }

  changeEntity(isHistoricalSearch = true, isFirst = false, isEntityChanged = false) {
    if (this.entityName != 'user') {
      this.role = null;
      this.subEntity = null;
    }
    else if (this.role != null) {
      this.subEntity = this.roles.find(r => r.value == this.role).label;
    }
    let searchEntity = this.subEntity == null ? this.entityName : this.subEntity;
    this.searchService.filters(searchEntity)
      .subscribe(r => {
        this.search.filters = r.body;
        this.form = new FormGroup({}, []);
        if (isEntityChanged) {
          this.clear();
          this.resetDuration();
        }
        //this.lookups = {};
        if (this.search.filters != null && this.search.filters.length > 0) {
          this.search.filters.forEach(f => {
            if (this.entityName == 'user' && this.role != null && f.key == 'roleId') {
              this.form.addControl(f.key, new FormControl(this.role));
              if (f.type == 'lookup' && f.lookupKey != null && this.lookups[f.lookupKey] == null) {
                this.loadLookup(f.lookupKey);
              }
              f.type = 'hidden';

            }
            else {
              if (f.type == 'zip') {
                this.form.addControl(f.key, new FormControl(f.value, [Validators.minLength(5), Validators.maxLength(5)]));
              } else if (f.type == 'phone') {
                this.form.addControl(f.key, new FormControl(f.value, [Validators.minLength(10), Validators.maxLength(18)]));
              } else {
                if (this.entityName == 'user' && ['phone', 'businessPhone'].includes(f.key)) {
                  this.form.addControl(f.key, new FormControl(f.value, [Validators.minLength(10), Validators.maxLength(18)]));
                } else {
                  this.form.addControl(f.key, new FormControl(f.value));
                }
              }
              if (f.type == 'lookup' && f.lookupKey != null && this.lookups[f.lookupKey] == null) {
                this.loadLookup(f.lookupKey);
              }
            }
          });
        } 

        this.visibleFilterOptions = this.search.filters.filter(f => f.type !== 'hidden');
        this.setFilterValuesFromForm();

        this.filtersChange.emit(this.search);
        if (isHistoricalSearch) {
          this.searchForm.reset();
          this.navigationService.setFilterSearch(this.search);
          this.navigationService.setSearchEntity(this.entityName, this.subEntity);
        }
        this.entityNameChange.emit({ entity: this.entityName, subEntity: this.subEntity });
        this.changeRef.markForCheck();
      });
  }


  clear() {
    for (let i = 0; i < this.selections.length; i++) {
      if (this.selections[i] != null) {
        if (this.form.contains(this.selections[i].key)) {
          this.form.get(this.selections[i].key).setValue(null);
          this.form.get(this.selections[i].key).updateValueAndValidity();
        }
      }
      this.selections[i] = null;
    }
    this.changeRef.markForCheck();
  }
  
  resetDuration() {
    this.search.duration = 1;
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe(r => {
        this.lookups[key] = r;
      });
  }

  changeDuration(){
     this.navigationService.setFilterSearch(this.search);
  }

  clickSearch(searchItem?:any) {
    if (searchItem == 'superSearch') {
      this.navigationService.callSuperSearchFunction(this.searchForm);
      this.subEntity = null;
      this.entityName = 'order';
      this.changeEntity(false);
      this.search.query = "";
      this.clear();
    } else {
      if (this.form.status === 'VALID') {
        this.setFilterValuesFromForm();
        this.navigationService.setFilterSearch(this.search);
        this.searchForm.reset();
        this.navigationService.setSearchEntity(this.entityName, this.subEntity);
        this.filtersChange.emit(this.search);
        this.navigationService.searchClick();
        this.onSearch.emit();
      }
    }
  }

  setFilterValuesFromForm() {
    if (this.search == null || this.search.filters == null || this.search.filters.length < 1)
      return;



    this.search.filters.forEach(f => {
      if (this.form.contains(f.key)) {
        let v = this.form.get(f.key).value;

        if ((f.type == "date" || f.type == "datetime") && v != null) {
          try {
            v = this.datePipe.transform(new Date(v), 'yyyy-MM-dd');
          }
          catch { }
        }

        f.value = v;
      } else {
        f.value = null;
      }
    });
  }

  select(i: number, e: any) {
    this.selectionLoading[i] = true;
    if (this.selections[i] != null && this.selections[i].key != e.key) {
      if (this.form.contains(this.selections[i].key)) {
        this.form.get(this.selections[i].key).setValue(null);
        this.form.get(this.selections[i].key).updateValueAndValidity();

      }
    }

    this.selections[i]= e;
    this.form.get(this.selections[i].key).setValue(null);
    this.form.get(this.selections[i].key).updateValueAndValidity();
    this.changeRef.markForCheck();

    setTimeout(() => { this.selectionLoading[i] = false; this.changeRef.markForCheck();}, 250);
  }

}


@NgModule({
  declarations: [
    SearchFilterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    PasswordModule,
    CheckboxModule,
    DropdownModule,
    InputMaskModule,
    KeyFilterModule,
    RadioButtonModule,
    CalendarModule,
    DynamicControlErrorModule,
    DynamicValueModule,
    InputTextModule,
    SimpleControlModule,
    DropdownModule,
    MultiSelectModule
  ],
  exports: [
    SearchFilterComponent
  ]
})
export class SearchFilterModule { }
